import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';

import {AppCommonsModule } from '../../../commons/app-commons.module';

import { PlessSharedModule } from '../../../shared/pless-shared.module';

import { KYMW1501Component } from './kymw1501.component';

import { DatePipe } from '@angular/common';

/**
 * マーク検索条件設定画面 モジュール設定クラス
 *
 * @export KYMW1501Module
 * @class KYMW1501Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjNavModule,
    WjInputModule,
  ],
  declarations: [
    KYMW1501Component,
  ],
  providers: [
    DatePipe,
  ],
})
export class KYMW1501Module {
}
